<section class="schedule-visit" *ngIf="getHeader$ | async as header">
  <section
    class="schedule-header"
    *ngIf="currentStep !== 5"
    [ngClass]="{ 'property-flow': isPropertyFlow }"
  >
    <div>
      <a (click)="goBack()" class="btn-without-filled without-border go-back">
        <span class="icon-Arrow-Back"></span>
        Regresar
      </a>
    </div>

    <div class="brand-info">
      <div class="wrapper-property-title">
        <h4>Agenda tu visita virtual</h4>
        <h4 *ngIf="currentStep !== 1">
          {{ service.getDataInProgress()?.propertyName }}
        </h4>
      </div>

      <section class="brand-logos">
        <section class="project-logo">
          <img [src]="header?.response?.projectLogo" />
        </section>
      </section>
    </div>
  </section>

  <div class="conteiner-sections-and-logo">
    <section class="schedule-visit-container">
      <section class="schedule-content">
        <div
          class="property-flow-steps"
          *ngIf="currentStep !== 5 && !isPropertyFlow"
        >
          <ng-container *ngFor="let indicator of stepsIndicators">
            <div
              class="step"
              *ngIf="indicator < 5"
              [ngClass]="{ active: indicator === currentStep }"
            >
              {{ indicator }}
            </div>
            <div class="line" *ngIf="indicator < 4"></div>
          </ng-container>
          <ng-container [ngSwitch]="currentStep">
            <span *ngSwitchCase="1">
              Selecciona la propiedad que te interesa
            </span>
            <span *ngSwitchCase="2"> Selecciona tus intereses </span>
            <span *ngSwitchCase="3"> Selecciona fecha y hora </span>
            <span *ngSwitchCase="4"> Regístrate con la opción que desees </span>
          </ng-container>
        </div>

        <div [ngSwitch]="currentStep">
          <div *ngSwitchCase="1">
            <ggi-journey-choose-department
              [typePropertySelected]="header?.response?.typePropertySelected"
              [typesProperty]="header?.response?.typesProperty"
              (canUserContinue)="canContinue($event)"
              (nextStep)="nextStep()"
            ></ggi-journey-choose-department>
          </div>
          <div *ngSwitchCase="2">
            <ggi-journey-preferences
              [typeProject]="this.params.typeProject"
              [saveData]="savePreference"
              (canUserContinue)="canContinue($event)"
              (doRequest)="scheduleVisitWithSession()"
            ></ggi-journey-preferences>
          </div>

          <div *ngSwitchCase="3">
            <ggi-journey-select-datetime
              [workingHours]="header?.response?.typeProject?.workingHours"
              [isPropertyFlow]="isPropertyFlow"
              (canUserContinue)="canContinue($event)"
            ></ggi-journey-select-datetime>
          </div>

          <div *ngSwitchCase="4">
            <ggi-journey-request-visit
              [isPropertyFlow]="isPropertyFlow"
              [tryContinue]="continueCount"
              (formPass)="formPassword($event)"
              (canUserContinue)="canContinue($event)"
              (setSignupResponse)="setSignupResponse($event)"
            ></ggi-journey-request-visit>
          </div>

          <div *ngSwitchCase="5">
            <ggi-journey-booking-summary
              [isPropertyFlow]="isPropertyFlow"
              [bookingSummary]="bookingSummary"
            ></ggi-journey-booking-summary>
          </div>
        </div>
      </section>
    </section>
  </div>

  <section
    class="schedule-footer"
    [ngClass]="{ 'button-go-login': currentStep === 4 }"
    *ngIf="currentStep !== 5"
  >
    <button
      class="btn-without-filled without-border"
      *ngIf="currentStep === 4"
      (click)="loginToCheckIn()"
    >
      Ya tengo cuenta
    </button>
    <button
      class="btn-filled"
      (click)="nextStep()"
      [innerHTML]="
        (currentStep === 4 || (currentStep === 3 && hasClientAccount)) &&
        !isPropertyFlow
          ? txtButtonFinish
          : txtButtonContinue
      "
    ></button>
  </section>

  <div class="footer-logos">
    <img src="assets/img/logos/BN5.png" alt="Grupo Gigante" />
    <img src="assets/img/logos/logo-powered.svg" alt="Powered by" />
  </div>
</section>
